import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function ResponsivePage() {
    return (
        <DocPage
            title="Responsive & Adaptive"
            description="Predictable breakpoint behavior — not 'make it responsive'."
        >
            <Section title="Breakpoints">
                <SpecTable
                    rows={[
                        ["xs 480", "Large phones"],
                        ["md 768", "Tablet — forms → 2 columns; sidebar may collapse"],
                        ["lg 1024", "Desktop shell with expanded sidebar"],
                        ["xl 1280", "Max content comfort"],
                    ]}
                />
            </Section>
            <Section title="Adaptations">
                <ul className="list-disc space-y-1 ps-5">
                    <li>Sidebar collapses to icons; Rider/Customer use BottomNav under `md`.</li>
                    <li>Tables scroll horizontally; keep primary identity column visible.</li>
                    <li>Modal nearly full-bleed on mobile; Drawer becomes full-height sheet.</li>
                    <li>
                        Action groups stack; primary action remains full-width on xs when alone.
                    </li>
                </ul>
            </Section>
        </DocPage>
    );
}
